@if (data) {
  <form [formGroup]="documentTypeForm" novalidate>
    <wcg-dialog [title]="data.title" class="w-full">
      <div
        class="w-full flex flex-col gap-8 mt-8 p-4 document-type-dialog__container"
        content
      >
        <!----------------------------Document Type---------------->
        <div class="w-full">
          <ng-container
            [ngTemplateOutlet]="inputField"
            [ngTemplateOutletContext]="{
              formControl: documentTypeForm.controls.name,
              props: {
                label: 'Document Type',
                isRequired: true,
                width: 'large',
                height: 'default',
                type: 'text',
                maxlength: 255,
                errorText: 'Document Type Name is required.',
                class: 'document-type-dialog__textWrapper',
                toolTipText: documentTypeForm.controls.name.value || '',
                disableToolTip: false,
                toolTipPosition: 'below',
              },
            }"
          />
        </div>
        <!----------------------/Document Type---------------->

        <!---------------------IsActive----------------------->
        <div class="w-full">
          <wcg-switch-new
            data-testid="document-type-dialog__slide-toggle"
            class="document-type-dialog__slide-toggle"
            colorVariant="default"
            formControlName="isActive"
          >
            Enabled
          </wcg-switch-new>
        </div>
        <!----------------------/IsActive--------------------->

        <!----------------Primary IRIS DOCUMENT ID--------------->
        <div class="w-full">
          <ng-container
            [ngTemplateOutlet]="inputField"
            [ngTemplateOutletContext]="{
              formControl: documentTypeForm.controls.primaryIrisDocumentId,
              props: {
                label: 'Primary IRIS Document ID',
                isRequired: true,
                width: 'large',
                type: 'text',
                maxlength: 3,
                errorText: 'IRIS Document ID is required.',
              },
            }"
          />
        </div>
        <!-------------/Primary IRIS DOCUMENT ID-------------->

        <!------------Additional IRIS DOCUMENT IDS------------>
        <div class="w-full">
          <ng-container
            [ngTemplateOutlet]="inputField"
            [ngTemplateOutletContext]="{
              formControl: documentTypeForm.controls.additionalIrisDocumentIds,
              props: {
                label: 'Additional IRIS Document IDs',
                isRequired: false,
                width: 'large',
                type: 'text',
                optionalMessage: 'Separate additional IDs with commas.',
              },
            }"
          />
        </div>
        <!------/Additional IRIS DOCUMENT IDS------------->
      </div>

      <!------------------Dialog Footer----------------->
      <div tertiary>
        <wcg-button
          color="tertiary"
          data-testid="document-type-dialog__cancel-btn"
          (click)="cancel()"
        >
          Cancel
        </wcg-button>
      </div>

      <div primary>
        <wcg-button
          data-testid="document-type-dialog__confirm-btn"
          color="primary"
          (click)="save()"
          [isDisabled]="!documentTypeForm.valid"
        >
          Save
        </wcg-button>
      </div>
      <!---------------/Dialog Footer----------------->
    </wcg-dialog>
  </form>
}

<!-- Input Field Component-->
<ng-template #inputField let-props="props" let-formControl="formControl">
  <wcg-input-field
    [class]="props.class"
    [type]="props.type"
    [formControl]="formControl"
    [width]="props.width"
    [height]="props.height ?? 'default'"
    [label]="props.label"
    [maxLength]="props.maxlength"
    [isRequired]="props.isRequired"
    [errorText]="
      formControl.hasError('numericError')
        ? primaryIRISDocumentNumericError()
        : formControl.hasError('serverError')
          ? serverError()
          : props.errorText
    "
    [toolTipText]="props.toolTipText"
    [disableToolTip]="props.disableToolTip"
    [toolTipPosition]="props.toolTipPosition"
    [toolTipClass]="props.toolTipClass"
    [toolTipHideDelay]="props.toolTipHideDelay"
  />
  @if (props.optionalMessage?.length > 0) {
    <span class="text-bluegrey-13">{{ props.optionalMessage }}</span>
  }
</ng-template>
<!--/Input Field Component-->

<!-- CheckBox Component-->
<ng-template #checkBoxes let-props="props" let-formControls="formControls">
  <div class="flex flex-col">
    <mat-label>
      {{ props.label }}
      @if (props?.isRequired) {
        <span class="text-red-12" data-testId="wcg-input-field__asterisk"
          >*</span
        >
      }
    </mat-label>
    <div class="relative right-4">
      <mat-checkbox color="primary" [formControl]="formControls.submission"
        >Submission</mat-checkbox
      >
      <mat-checkbox color="primary" [formControl]="formControls.outcome"
        >Outcome</mat-checkbox
      >
    </div>
  </div>
</ng-template>
<!-- /CheckBox Component-->
